module.exports = __webpack_public_path__ + "media/images/bee-57f62c1471ee40c630f1017cb325d632.gif";